export const COACH_ACTIVITY_STATUS = {
  PENDING: 'Pending',
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  REJECTED: 'Rejected'
};

export const CONTINUE_APPLICATION_BUTTON_TEXT = {
  [COACH_ACTIVITY_STATUS.PENDING]: 'Continue Application',
  [COACH_ACTIVITY_STATUS.SUBMITTED]: 'Review Application',
  [COACH_ACTIVITY_STATUS.REJECTED]: 'Revise Application',
  [COACH_ACTIVITY_STATUS.APPROVED]: 'Edit Pro Settings'
};
